export default __webpack_public_path__ + "static/media/116.ca58ea7d.webp";